/**
 * Cart drawer:
 * 1) Repair blank rows (prices only / missing titles)
 * 2) Show LINE TOTAL next to each product (unit × qty) so Ulisis’s “circled number” moves
 * 3) Keep CHECK OUT [data-cart-final] on Shopify cart.total_price (discounts included)
 */
(function () {
  if (window.__vpDrawerRepairInit) return;
  window.__vpDrawerRepairInit = true;

  var repairing = false;

  function drawerRoot() {
    return document.getElementById('drawer-cart');
  }

  function linesBox(drawer) {
    return drawer && drawer.querySelector('[data-line-items]');
  }

  function isBroken(items) {
    if (!items) return false;
    var rows = items.querySelectorAll('.cart__items__row');
    if (!rows.length) return false;
    var bad = 0;
    rows.forEach(function (row) {
      var title = row.querySelector('.cart__items__title');
      var titleText = title ? (title.textContent || '').replace(/\s+/g, ' ').trim() : '';
      var qty = row.querySelector('[data-update-cart], [data-quantity-input]');
      var imgWrap = row.querySelector('.cart__items__image');
      if (!titleText || titleText.length < 2) bad++;
      else if (!qty) bad++;
      else if (!imgWrap) bad++;
    });
    return bad >= Math.ceil(rows.length / 2);
  }

  function money(cents) {
    var n = Number(cents);
    if (isNaN(n)) n = 0;
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(n, (window.theme && theme.moneyFormat) || '${{amount}}');
      }
    } catch (e) {}
    return '$' + (n / 100).toFixed(2);
  }

  function parseMoney(text) {
    if (text == null) return 0;
    var s = String(text).replace(/[^0-9.]/g, '');
    if (!s) return 0;
    var n = parseFloat(s);
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  function visiblePriceNodes(row) {
    var nodes = [];
    // Prefer the Pipeline line-total column (now shown in drawer via CSS)
    row.querySelectorAll('.cart__items__total [data-wpd-cart-line-price], .cart__items__total [data-wpd-cart-drawer-line-price]').forEach(function (el) {
      nodes.push(el);
    });
    row.querySelectorAll('[data-vp-drawer-line-total], .cart__items__price [data-cart-item-price]').forEach(function (el) {
      if (el.hasAttribute('data-cart-item-original-price')) return;
      if (el.closest('del')) return;
      nodes.push(el);
    });
    return nodes;
  }

  function strikeNodes(row) {
    return row.querySelectorAll(
      '.cart__items__price [data-cart-item-original-price], .cart__items__price del span'
    );
  }

  function unitForRow(row, key, item) {
    var vid =
      (item && item.variant_id) ||
      parseInt(row.getAttribute('data-vp-variant-id'), 10) ||
      (row.querySelector('[data-wpd-cart-variant-id]') &&
        parseInt(row.querySelector('[data-wpd-cart-variant-id]').getAttribute('data-wpd-cart-variant-id'), 10)) ||
      0;
    if (key && window.__vpMayoristaUnitLock && window.__vpMayoristaUnitLock[key]) {
      return window.__vpMayoristaUnitLock[key];
    }
    if (vid && window.__vpMayoristaUnitLockByVid && window.__vpMayoristaUnitLockByVid[vid]) {
      return window.__vpMayoristaUnitLockByVid[vid];
    }
    var stored = parseInt(row.getAttribute('data-vp-unit-cents'), 10) || 0;
    if (stored > 0) return stored;
    var unitEl =
      row.querySelector('[data-vp-drawer-unit], .vp-drawer-unit-price, [data-vp-unit-price]');
    if (unitEl) {
      var parsedUnit = parseMoney(unitEl.textContent);
      if (parsedUnit > 0) return parsedUnit;
    }
    // Do not use Shopify cart.final_price for mayorista — often still boutique/wrong vs IVP
    var isMayorista = !!(window.__vpMayoristaCart && window.__vpMayoristaCart.enabled);
    if (!isMayorista && item && (item.final_price != null || item.price != null)) {
      return item.final_price != null ? item.final_price : item.price;
    }
    var attr = row.querySelector('[data-wpd-cart-drawer-variant-price]');
    var boutique = attr ? parseInt(attr.getAttribute('data-wpd-cart-drawer-variant-price'), 10) || 0 : 0;
    return boutique;
  }

  function retailForRow(row, item) {
    var attr = row.querySelector('[data-wpd-cart-drawer-variant-price]');
    var boutique = attr ? parseInt(attr.getAttribute('data-wpd-cart-drawer-variant-price'), 10) || 0 : 0;
    if (boutique) return boutique;
    if (item && item.original_price) return item.original_price;
    if (item && item.price) return item.price;
    return 0;
  }

  /** Ulisis: the number beside the product must be LINE TOTAL (changes with qty). */
  function paintDrawerLineTotals(cart) {
    var drawer = drawerRoot();
    if (!drawer) return;

    var byKey = {};
    if (cart && Array.isArray(cart.items)) {
      cart.items.forEach(function (item) {
        if (item && item.key) byKey[item.key] = item;
      });
    }

    drawer.querySelectorAll('.cart__items__row').forEach(function (row) {
      var input = row.querySelector('[data-update-cart]');
      var key = (input && input.getAttribute('data-update-cart')) || row.getAttribute('data-wpd-cart-item') || '';
      var item = key ? byKey[key] : null;
      var qty = input ? parseInt(input.value, 10) : item ? item.quantity : 1;
      if (isNaN(qty) || qty < 0) qty = item && item.quantity ? item.quantity : 1;

      var unit = unitForRow(row, key, item);
      if (!unit) return;
      row.setAttribute('data-vp-unit-cents', String(unit));

      var line = unit * qty;
      var retail = retailForRow(row, item);
      var lineText = money(line);
      var unitText = money(unit);

      var unitEl = row.querySelector('[data-vp-drawer-unit], .vp-drawer-unit-price');
      if (unitEl) {
        unitEl.innerHTML =
          unitText + ' <span class="vp-drawer-unit-each">each</span>';
      }

      row.querySelectorAll('.vp-drawer-line-total, .cart__items__total [data-wpd-cart-line-price], .cart__items__total [data-wpd-cart-drawer-line-price]').forEach(function (el) {
        if (el.matches('[data-vp-drawer-unit], .vp-drawer-unit-price') || el.closest('[data-vp-drawer-unit]')) return;
        el.textContent = lineText;
      });

      visiblePriceNodes(row).forEach(function (el) {
        if (el.matches('[data-vp-drawer-unit], .vp-drawer-unit-price') || el.querySelector('.vp-drawer-unit-each')) return;
        el.textContent = lineText;
      });

      if (retail > unit) {
        var retailLine = money(retail * qty);
        strikeNodes(row).forEach(function (el) {
          el.textContent = money(retail);
          var del = el.closest('del');
          if (del) {
            del.style.display = '';
            del.classList.remove('data-wpd-hide');
          }
        });
      }
    });

    if (cart && cart.total_price != null) {
      var isMayorista = !!(window.__vpMayoristaCart && window.__vpMayoristaCart.enabled);
      if (isMayorista) {
        // Preferential sum already painted into line nodes — sum them for checkout
        var sum = 0;
        drawer.querySelectorAll('.cart__items__row').forEach(function (row) {
          var input = row.querySelector('[data-update-cart]');
          var key = input && input.getAttribute('data-update-cart');
          var qty = input ? parseInt(input.value, 10) : 1;
          if (isNaN(qty)) qty = 1;
          var unit = unitForRow(row, key, key && byKey[key]);
          sum += unit * qty;
        });
        if (sum > 0) {
          var t = money(sum);
          drawer.querySelectorAll('[data-cart-final]').forEach(function (el) {
            el.textContent = t + (window.theme && theme.currencyCode ? ' ' + theme.currencyCode : '');
          });
          return;
        }
      }
      var text = money(cart.total_price);
      if (window.theme && theme.currencyCode && String(text).indexOf(theme.currencyCode) === -1) {
        text += ' ' + theme.currencyCode;
      }
      drawer.querySelectorAll('[data-cart-final]').forEach(function (el) {
        el.textContent = text;
      });
    }
  }

  function paintOptimisticFromInputs() {
    paintDrawerLineTotals(null);
    var sum = 0;
    var drawer = drawerRoot();
    if (!drawer) return;
    drawer.querySelectorAll('.cart__items__row').forEach(function (row) {
      var input = row.querySelector('[data-update-cart]');
      var key = input && input.getAttribute('data-update-cart');
      var qty = input ? parseInt(input.value, 10) : 1;
      if (isNaN(qty)) qty = 1;
      sum += unitForRow(row, key, null) * qty;
    });
    if (sum > 0) {
      var t = money(sum);
      drawer.querySelectorAll('[data-cart-final]').forEach(function (el) {
        el.textContent = t + (window.theme && theme.currencyCode ? ' ' + theme.currencyCode : '');
      });
    }
  }

  function refreshFromCartJs() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        paintDrawerLineTotals(cart);
        try {
          if (typeof window.wcpApplyLinePrices === 'function') window.wcpApplyLinePrices();
        } catch (e) {}
        // Re-assert line totals after WPD may rewrite units
        setTimeout(function () {
          paintDrawerLineTotals(cart);
        }, 200);
        setTimeout(function () {
          paintDrawerLineTotals(cart);
        }, 600);
      })
      .catch(function () {
        paintOptimisticFromInputs();
      });
  }

  function repair() {
    var drawer = drawerRoot();
    var items = linesBox(drawer);
    if (!items || repairing) return;

    refreshFromCartJs();

    if (!isBroken(items)) return;

    repairing = true;
    var root = (window.theme && theme.routes && theme.routes.root_url) || '/';
    if (root.slice(-1) !== '/') root += '/';

    fetch(root + '?section_id=api-cart-items', { credentials: 'same-origin' })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = document.createElement('div');
        doc.innerHTML = html;
        var fresh = doc.querySelector('[data-api-content]');
        if (!fresh || fresh.innerHTML.indexOf('cart__items__title') === -1) return;
        items.innerHTML = fresh.innerHTML;
        try {
          if (typeof window.wcpApplyLinePrices === 'function') window.wcpApplyLinePrices();
        } catch (e) {}
        refreshFromCartJs();
      })
      .catch(function () {})
      .finally(function () {
        repairing = false;
      });
  }

  document.addEventListener('theme:drawer:open', function () {
    setTimeout(repair, 200);
    setTimeout(refreshFromCartJs, 500);
    setTimeout(refreshFromCartJs, 1100);
  });

  document.addEventListener('theme:cart:change', function () {
    setTimeout(refreshFromCartJs, 100);
    setTimeout(refreshFromCartJs, 450);
    setTimeout(repair, 800);
  });

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      var drawer = drawerRoot();
      if (!drawer || !drawer.contains(e.target)) return;
      if (!e.target.closest('[data-increase-quantity], [data-decrease-quantity], [data-remove-key]')) return;
      // After theme bumps the input, paint line totals immediately
      setTimeout(paintOptimisticFromInputs, 0);
      setTimeout(paintOptimisticFromInputs, 40);
      setTimeout(refreshFromCartJs, 350);
      setTimeout(refreshFromCartJs, 900);
    },
    true
  );

  document.addEventListener(
    'change',
    function (e) {
      if (!e.target || !e.target.getAttribute) return;
      var drawer = drawerRoot();
      if (!drawer || !drawer.contains(e.target)) return;
      if (!e.target.getAttribute('data-update-cart')) return;
      paintOptimisticFromInputs();
      setTimeout(refreshFromCartJs, 300);
    },
    true
  );
})();
